/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling

//3rd Party Components
import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import { withRouter } from "react-router-dom";
import AUbutton from '@gov.au/buttons';
import AUbreadcrumbs from '@gov.au/breadcrumbs';
import AUpageAlert from '@gov.au/page-alerts';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Heading from '../components/CASA/Heading';
import ProcessMessage from '../components/Portal/ProcessMessage';
import SimpleTable from '../components/Portal/SimpleTable ';

//Actions
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getOrganisationUsers } from '../PortalStore/Actions/OrganisationUsersActions';
import { urlSearchValue } from '../components/Portal/Utilities';

class OrgManageUsersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageOrgManageUsersLoaded: false,
            orgid: urlSearchValue('casaorgid'), //should check for null and is guid
            userid: this.props.userdetails.items.value[0].contactid,
            pageOrgManageUsersError: false,
            pageOrgManageUsersErrorMessage: "",
            orgroleaddsuccess: urlSearchValue('orgroleaddsuccess'),
            orgroleremovesuccess: urlSearchValue('orgroleremovesuccess')
        }

    }

    componentDidMount() {
        if (this.state.userid !== '') {
            this.loadData();
        }
    }

    AEMParameters(arn) {
        var crumbs = [
            {
                link: this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - Home URL").casa_stringvalue + "/dashorg?casaorgid=" + this.state.orgid,
                text: 'myCASA'
            },

            {
                link: this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - PortalUI Base Url").casa_stringvalue + "/orgmanageusers?casaorgid=" + this.state.orgid,
                text: 'Manage users'
            }
        ];

        if (arn != "") {
            var aparams = {
                'organisationId': this.state.orgid,
                'orgarn': this.props.organisationUsers.items.data.value.length > 0 ? this.props.organisationUsers.items.data.value[0].organisationarn : '',
                'arn': arn,
                'breadcrumbs': crumbs
            };

            return encodeURIComponent(btoa(JSON.stringify(aparams)));
        }

        var params = {
            'organisationId': this.state.orgid,
            'orgarn': this.props.organisationUsers.items.data.value.length > 0 ? this.props.organisationUsers.items.data.value[0].organisationarn : '',
            'breadcrumbs': crumbs
        };

        return encodeURIComponent(btoa(JSON.stringify(params)));

    }

    CreateOrgURL() {

        let url = this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - AEM URL").casa_stringvalue;
        return url + "/content/casa/home/forms/organisational-role-management.html?params=" + this.AEMParameters();
    }

    AddUser() {

        let url = this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - AEM URL").casa_stringvalue + "/content/casa/home/forms/organisational-role-management.html?params=" + this.AEMParameters();
        window.location = url;
    }

    CreateUserUrl(row) {

        var url = this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - AEM URL").casa_stringvalue;

        return url + "/content/casa/home/forms/organisational-role-management.html?from=portal&params=" + this.AEMParameters(row.arn);
    }

    loadData = () => {

        const webappurl = this.props.B2CSettings.items.webappurlPortalApi;

        let tokenRequest = {
            scopes: [this.props.B2CSettings.items.ScopesPortal]
        }

        axios.all([
            this.props.dispatch(getOrganisationUsers(webappurl, this.props.B2CSettings.items.accesstokenPortal, this.state.orgid))
        ])
            .then(responseArr => {
                var success = 0;
                var errmsg = '';
                for (var i = 0; i < responseArr.length; i++) {
                    if (responseArr[i].type.includes("FAILURE")) {
                        errmsg += responseArr[i].payload.error + " ";
                    }
                    if (responseArr[i].type.includes("SUCCESS")) {
                        success++;
                    }
                }
                if (success === responseArr.length) {
                    this.setState({ pageOrgManageUsersLoaded: true });
                }
                else {
                    this.setState({ pageOrgManageUsersLoaded: true, pageOrgManageUsersLoadedError: true, pageOrgManageUsersLoadedErrorMessage: errmsg });

                    var msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    var details = "Details: " + errmsg;
                    this.props.dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            });
    }

    OrgUsers = () => {

        if (this.props.organisationUsers.items.data.activealert == true) {
            this.props.dispatch(addPageAlert({ level: "error", title: "Role and user management is currently unavailable" }));
        }

        var users = this.props.organisationUsers.items.data.value;

        const cols = [
            {
                property: 'fullname',
                label: 'Name',
                type: 'string',
                isCommand: this.props.organisationUsers.items.data.enableadduser,
                commandLink: (row) => {
                    const url = this.CreateUserUrl(row);
                    window.location = url;
                },
                width: "25%"
            },

            {
                property: 'arn',
                label: 'ARN',
                type: 'string',
                isCommand: false,
                width: "50%"
            }

        ];

        return (
            <Fragment>
                <SimpleTable data={users.filter(obj => {
                    return obj.role === "Contact Person"
                })}
                    columns={cols}
                    caption={"Contact persons"}
                    subcaption={"Contact persons will receive messages from CASA on behalf of their organisation. They can also view their organisation's myCASA profile and submission summary. Find out more about the contact person role on the <a href='https://www.casa.gov.au/organisational-aviation-reference-number-application'>CASA website.</a>"}
                    includeEmptyRow={true} />

                <br />

                <SimpleTable data={users.filter(obj => {
                    return obj.role === "Authorised Representative"
                })}
                    columns={cols}
                    caption={"Authorised representatives"}
                    subcaption={"An authorised representative can access services on behalf of an organisation in myCASA, add and remove users and update contact details. Find out more about the authorised representative role on the <a href='https://www.casa.gov.au/organisational-aviation-reference-number-application'>CASA website.</a>"}
                    includeEmptyRow={true} />
                <br />


                <span>
                    <SimpleTable data={users.filter(obj => { return (obj.role === "Owner") || (obj.role === "Chief Executive Officer") || (obj.role === "Director"); })}
                        columns={cols}
                        caption={"Executive roles"}
                        subcaption={"Executive roles have the authority in an organisation for managing certificates and other details of the organisation. To change executive roles of your organisation, <a href='https://www.casa.gov.au/about-us/contact-us'>please contact CASA.</a>"}
                        includeEmptyRow={true} />
                </span>
                <br />

                <SimpleTable data={users.filter(obj => {
                    return obj.role === "DAMP Contact"
                })}
                    columns={cols}
                    caption={"DAMP contact"}
                    subcaption={"This person is your organisation’s primary contact with CASA regarding the responsibilities of your drug and alcohol management program (DAMP). To change your DAMP contact, <a href='https://www.casa.gov.au/about-us/contact-us'>please contact CASA.</a>"}
                    includeEmptyRow={true} />
            </Fragment>
        )
    }

    AddUsersButton = () => {
        return (
            <Fragment>

                {
                    (this.props.organisationUsers.items.data.enableadduser) &&
                    <span>
                        <br />
                        <AUbutton id="btnAddUsers" className="au-btn au-btn--secondary" onClick={() => this.AddUser()}>Add user</AUbutton>
                    </span>
                }

                {
                    (this.props.organisationUsers.items.data.enableadduser === false) &&
                    <span>
                        <br />
                        <AUbutton id="btnAddUsers" className="au-btn au-btn--secondary" disabled>Add user</AUbutton>
                    </span>
                }
            </Fragment>
        )
    }

    DisplayMessages = () => {

        return (
            <Fragment>

                {
                    (this.state.orgroleaddsuccess == "1") &&

                    <AUpageAlert as="success">
                        <h3>Role(s) added</h3>
                        <p />
                        <p>
                            A confirmation of the additional role(s) has been sent to your organisation&apos;s email address <b>{this.props.organisationUsers.items.data.orgemailaddress}</b> as well as the users email address
                        </p>
                        <p>
                            Please note any roles added recently may take a few minutes to appear below.
                        </p>
                    </AUpageAlert>
                }

                {
                    (this.state.orgroleremovesuccess == "1") &&

                    <AUpageAlert as="success">
                        <h3>Role removed</h3>
                        <p />
                        <p>
                            A confirmation of this role removal has been sent to your organisation&apos;s email <b>{this.props.organisationUsers.items.data.orgemailaddress}</b> as well as the users email address
                        </p>
                        <p>
                            Please note any roles removed recently may take a few minutes to update below.
                         </p>
                    </AUpageAlert>
                }
            </Fragment>
        )
    }

    showSpinner = () => {
        if (!this.state.pageOrgManageUsersLoadedError) {
            return (<CASASpinner message="Working. Please wait....." />);
        }
        else {
            return null;
        }
    }

    render() {

        var returnLink = this.props.envdata.items.systemsettings.value.find(el => el.casa_name === "Portal - Home URL").casa_stringvalue + "/dashorg?casaorgid=" + this.state.orgid;

        var items = [];
        var showItems = false;

        items = [
            {
                text: 'myCASA',
                link: returnLink
            },
            {
                text: 'Manage roles and users'
            }
        ];
        showItems = false;


        if (!this.state.pageOrgManageUsersLoaded) {
            return (
                <Fragment>
                    <MetaTags>
                        <title>Manage roles and users</title>
                    </MetaTags>

                    {this.showSpinner()}

                </Fragment>
            )

        }

        return (
            <Fragment>
                <MetaTags>
                    <title>Manage roles and users</title>
                </MetaTags>

                <AUbreadcrumbs label="Breadcrumb for this page"
                    items={items} />

                <ProcessMessage />

                {this.DisplayMessages()}

                <Heading
                    id="pageheading"
                    text="Manage roles and users"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={true} />

                {this.AddUsersButton()}
                <br /><br />
                {this.OrgUsers()}
                {this.AddUsersButton()}

                <p>
                    <a className="au-direction-link au-direction-link--left" href={returnLink}>Return to myCASA</a>
                </p>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userdetails: state.userdetails,
        envdata: state.envdata,
        organisationUsers: state.organisationUsers,
        B2CSettings: state.B2CSettings,
        ClientApp: state.ClientApp
    }
}

export default withRouter(connect(mapStateToProps)(OrgManageUsersPage));